// extracted by mini-css-extract-plugin
module.exports = {"title":"confirmDialog_title__1Trwg","actions":"confirmDialog_actions__2qmM0","text":"confirmDialog_text__foIgH"};
    if(module.hot) {
      // 1790670234286
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  